var map = {
	"./icon-1-inhabitant.svg": "GzSs",
	"./icon-2-inhabitant.svg": "Iaa7",
	"./icon-25-area.svg": "0EOA",
	"./icon-3-inhabitant.svg": "b7zb",
	"./icon-4-inhabitant.svg": "tA1S",
	"./icon-50-area.svg": "/Qmr",
	"./icon-75-area.svg": "rWEm",
	"./icon-arrow-bottom.svg": "ka2k",
	"./icon-decrease.svg": "ffZO",
	"./icon-description-contractType.svg": "EAzi",
	"./icon-description-description.svg": "bNNX",
	"./icon-description-duration.svg": "zqdZ",
	"./icon-description-fix.svg": "OXFU",
	"./icon-description-green.svg": "vhoQ",
	"./icon-description-invoiceModes.svg": "EIOw",
	"./icon-description-longer.svg": "sAAi",
	"./icon-description-paymentModes.svg": "TGlp",
	"./icon-description-price.svg": "15b4",
	"./icon-description-serviceLevels.svg": "MDX8",
	"./icon-dishwasher.svg": "PwJT",
	"./icon-dryer.svg": "cEd5",
	"./icon-dual.svg": "1jLa",
	"./icon-easy.svg": "fUs2",
	"./icon-economy - Copy.svg": "otYS",
	"./icon-economy.svg": "vZbS",
	"./icon-economy1.svg": "v0OZ",
	"./icon-economy2.svg": "t7Ls",
	"./icon-elec.svg": "Gytu",
	"./icon-empty-house.svg": "02aJ",
	"./icon-exclusiveNight.svg": "vMQ/",
	"./icon-gas.svg": "sBEU",
	"./icon-heater_pump.svg": "aaaQ",
	"./icon-help.svg": "fRhn",
	"./icon-increase.svg": "h+cb",
	"./icon-loader.svg": "gnr6",
	"./icon-mobile-menu-close.svg": "c0ZG",
	"./icon-mobile-menu.svg": "xpr3",
	"./icon-mono.svg": "xLe4",
	"./icon-occupation-always.svg": "3n9X",
	"./icon-occupation-evening_weekend.svg": "3WW0",
	"./icon-occupation-evening_weekend2.svg": "5LUe",
	"./icon-occupation-summer.svg": "fzVV",
	"./icon-occupation-weekend_holidays.svg": "Wav+",
	"./icon-other.svg": "aecE",
	"./icon-product-COMFY.svg": "MaEq",
	"./icon-product-EASY.svg": "ktVr",
	"./icon-product-GROUP.svg": "hwPf",
	"./icon-product-SUPER.svg": "eDDI",
	"./icon-product-ZEN.svg": "Vg0c",
	"./icon-quick.svg": "3ts+",
	"./icon-solar-panel.svg": "iWhp",
	"./icon-step-calculation.svg": "76co",
	"./icon-step-consumption.svg": "BQ8E",
	"./icon-step-contact.svg": "DoUr",
	"./icon-step-energy.svg": "4gay",
	"./icon-summer (2).svg": "CmSB",
	"./icon-tou.svg": "gJqF",
	"./icon-unknown.svg": "9NSS",
	"./icon-washingmachine.svg": "NM9d"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lUul";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ./node_modules/html-loader ^\.\/icon\-.*\.svg$
// module id = lUul
// module chunks = 1